import { useState } from 'react';
import { Check, Info } from 'lucide-react';

export interface MMRCResultPayload {
  grade: number;
  description: string;
  finishedAt?: string;
}

interface MMRCTestProps {
  initial?: number;
  onCancel?: () => void;
  onNext: (result: MMRCResultPayload) => void;
}

export const MMRC_ITEMS = [
  { grade: 0, text: 'Só sente falta de ar durante exercícios intensos.' },
  { grade: 1, text: 'Sente falta de ar ao andar apressado no plano ou ao subir uma ladeira leve.' },
  { grade: 2, text: 'Anda mais devagar que pessoas da mesma idade por causa da falta de ar ou precisa parar para respirar mesmo em passo habitual.' },
  { grade: 3, text: 'Precisa parar para respirar após caminhar cerca de 100 metros ou depois de alguns minutos no plano.' },
  { grade: 4, text: 'Sente tanta falta de ar que não consegue sair de casa ou fica dispneico ao se vestir.' },
] as const;

export default function MMRCTest({ initial, onCancel, onNext }: MMRCTestProps) {
  const [selected, setSelected] = useState<number | null>(initial ?? null);

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-2 rounded-md bg-blue-50 p-3 text-blue-900">
        <Info className="mt-0.5 h-5 w-5" />
        <div>
          <p className="font-medium">Escala mMRC de dispneia</p>
          <p className="text-sm opacity-90">Selecione um grau de 0 a 4 conforme a limitação respiratória percebida.</p>
        </div>
      </div>

      <div className="space-y-2">
        {MMRC_ITEMS.map((item) => (
          <label
            key={item.grade}
            className={`flex cursor-pointer gap-3 rounded-xl border p-4 transition ${
              selected === item.grade ? 'border-blue-600 bg-blue-600 text-white' : 'bg-white hover:bg-slate-50'
            }`}
          >
            <input
              type="radio"
              name="mmrc_v2"
              className="mt-1"
              checked={selected === item.grade}
              onChange={() => setSelected(item.grade)}
            />
            <div>
              <div className="font-semibold">Grau {item.grade}</div>
              <div className="mt-1 text-sm opacity-90">{item.text}</div>
            </div>
          </label>
        ))}
      </div>

      <div className="flex items-center justify-between pt-2">
        <button type="button" className="text-sm text-gray-600 hover:text-gray-800" onClick={onCancel}>
          Cancelar
        </button>
        <button
          type="button"
          className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-white disabled:opacity-50"
          disabled={selected == null}
          onClick={() =>
            selected != null &&
            onNext({
              grade: selected,
              description: MMRC_ITEMS.find((item) => item.grade === selected)?.text ?? '',
              finishedAt: new Date().toISOString(),
            })
          }
        >
          Concluir mMRC
          <Check className="ml-1 h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
